import { MainMenu } from '@/components/shared/navigation';

export const PlatformHomePage = () => {
  return <MainMenu mode="platform" backPath="/menu" />;
};
